import LazyLoad from 'vanilla-lazyload';

import './modules/preload';
import './modules/header';
import './modules/sliders';
import './modules/productsNav';
import './modules/input';
import './modules/collapse';
import './modules/faqSearch';
import './modules/kitSearch';
import './modules/gallery';
import './modules/tabs';
import './modules/download';
import './modules/alert';
import './modules/share';
import './modules/toTop';
// import './modules/add2kit';
import './modules/load-more';
import './modules/add-to-cart';
import './modules/cart';
import './modules/custom-select';
import './modules/shippingCalculator';
import anniversary from './modules/anniversary';
import blog from './modules/blog';

window.lazyLoadInstance = new LazyLoad();

document.addEventListener('DOMContentLoaded', () => {
  window.lazyLoadInstance.update();
  anniversary();
  blog();
});
